module.exports = __webpack_public_path__ + "static/media/Custom Software Icon.350387f5.svg";